module.exports = {"230113001":"双城市街道管委会","230113002":"五家街道","230113003":"新兴街道","230113004":"兰棱街道","230113005":"周家街道","230113006":"公正街道","230113007":"承旭街道","230113008":"承恩街道","230113009":"永治街道","230113010":"永和街道","230113011":"幸福街道","230113104":"韩甸镇","230113105":"单城镇","230113106":"东官镇","230113107":"农丰满族锡伯族镇","230113108":"杏山镇","230113109":"西官镇","230113200":"朝阳乡","230113201":"金城乡","230113203":"青岭满族乡","230113204":"联兴满族乡","230113208":"永胜乡","230113209":"临江乡","230113210":"水泉乡","230113211":"乐群满族乡","230113214":"万隆乡","230113216":"希勤满族乡","230113217":"同心满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230113.json
// module id = 623
// module chunks = 0